var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-body",attrs:{"ui-view":"","id":"view"}},[_c('div',{staticClass:"app-body",attrs:{"ui-view":"","id":"view"}},[_c('page-header',{attrs:{"title":"사이트 관리","description":"VMS 사이트 내부 보안서약서, 반입자산 종류, 체크리스트를 관리합니다."}}),_c('div',{staticClass:"page-body ph-30"},[_c('tos-list'),_c('asset-list'),_c('check-list')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }